import { quotesForLoading } from './loadingDialogQuotes';
import { Modal } from '@startuptools/ui/Modal';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { Alert } from '@startuptools/ui/Alert';
import { LinearProgress } from '@startuptools/ui/LinearProgress';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

const getRandomQuote = (quotes: { content: string; author: string }[]) => {
  const randomIndex = Math.floor(Math.random() * quotes.length);
  return quotes[randomIndex];
};

export const LoadingDialog = () => {
  const randomQuote = getRandomQuote(quotesForLoading);

  return (
    <Modal open onClose={() => null}>
      <ModalDialog>
        <Stack gap={3} margin={1}>
          <Alert startDecorator={<FormatQuoteIcon fontSize="large" color="primary" />} size="lg">
            <Stack direction="column" gap={1}>
              {/*
               // @ts-expect-error TS18048 */}
              <Box>{randomQuote.content}</Box>
              {/*
               // @ts-expect-error TS18048 */}
              <Box alignSelf="end">- {randomQuote.author}</Box>
              <LinearProgress color="neutral" />
            </Stack>
          </Alert>
        </Stack>
      </ModalDialog>
    </Modal>
  );
};
